/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Value_HeaderInputs */



/**
* | output |
* | --- |
* | "Value" |
*
* @param {Explorer_Info_Value_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_value_header = /** @type {((inputs?: Explorer_Info_Value_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Value_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Valeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ценить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Valor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("价值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("価値")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कीमत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Valor")
	return /** @type {LocalizedString} */ ("Value")
});